/* lp-parallax.js — parallax for the banner photographs ON PHONES ONLY.
   Desktop keeps background-attachment:fixed and never runs any of this.

   Why it exists: a phone browser cannot paint a fixed background (iOS renders it blank), so the
   prototype falls back to background-attachment:scroll below 900px. That locks the photograph to its
   band — the two scroll together, so nothing moves and the picture reads as a stuck crop. Luke asked
   for movement on phones without changing desktop (17 Sep 2026). Below 900px the photograph therefore
   moves to an inner layer that is taller than the band, and this file translates that layer as the band
   crosses the viewport: the image drifts down while the band travels up, so it appears to lag the page
   the way the desktop's fixed background does.

   translate3d on a single layer, read in one batch and written in one batch inside a rAF, so a scroll
   costs one composited transform per visible band and no layout. Reduced-motion visitors get no
   transform at all (the CSS also pins it), and the layer is simply the photograph, so if this script
   never runs the band still looks exactly as it does today. */
(function () {
  'use strict';
  if (window.__lpParallax || !window.matchMedia || !window.requestAnimationFrame) return;
  window.__lpParallax = true;

  var OVER = 0.18;                 /* must match --plx-over in lp-tokens.css: 18% above and below */
  var phone = matchMedia('(max-width:900px)');
  var still = matchMedia('(prefers-reduced-motion: reduce)');
  var layers = [];
  var ticking = false;

  function collect() {
    layers = Array.prototype.slice.call(document.querySelectorAll('.lp-plx > .plx-layer'));
  }

  function paint() {
    ticking = false;
    if (!layers.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    /* read every rect first, then write every transform — never interleaved, or each write
       invalidates layout for the next read */
    var i, box = [];
    for (i = 0; i < layers.length; i++) {
      var host = layers[i].parentElement;
      box.push(host ? host.getBoundingClientRect() : null);
    }
    for (i = 0; i < layers.length; i++) {
      var r = box[i];
      if (!r || !r.height) continue;
      if (r.bottom < -120 || r.top > vh + 120) continue;      /* well off screen: leave it alone */
      var p = (vh - r.top) / (vh + r.height);                  /* 0 entering at the bottom, 1 leaving at the top */
      if (p < 0) p = 0; else if (p > 1) p = 1;
      var travel = r.height * OVER;
      /* (p - 0.5): the image sits high as the band enters and drifts down as it leaves, so it moves
         LESS than the page does — a background that lags. The opposite sign reads as the picture
         racing the page, which is the thing that looks wrong. */
      layers[i].style.transform = 'translate3d(0,' + ((p - 0.5) * 2 * travel).toFixed(1) + 'px,0)';
    }
  }

  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }

  var bound = false;
  function bind() {
    if (bound) return; bound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* Horizon scrolls .page-wrapper instead of the window at >=990px; below that the document scrolls,
       but bind both so a tablet in the overlap behaves */
    var wrap = document.querySelector('.page-wrapper');
    if (wrap) wrap.addEventListener('scroll', onScroll, { passive: true });
  }
  function unbind() {
    if (!bound) return; bound = false;
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    var wrap = document.querySelector('.page-wrapper');
    if (wrap) wrap.removeEventListener('scroll', onScroll);
    layers.forEach(function (l) { l.style.transform = ''; });
  }

  function sync() {
    collect();
    if (phone.matches && !still.matches && layers.length) { bind(); paint(); }
    else unbind();
  }

  var on = phone.addEventListener ? 'addEventListener' : 'addListener';
  phone[on]('change', sync);
  still[on]('change', sync);
  document.addEventListener('shopify:section:load', sync);     /* the theme editor re-renders sections */
  document.addEventListener('shopify:section:unload', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
